import operatorApiService from "../../../services/operator-api.service";
import { OnevehicleInitData } from "../../../types/onevehicle";

const startLayoutCheck = (
  initData: OnevehicleInitData | null,
  monitorConsoleId: number
) => {
  const checkVehicleLayout = async () => {
    if (!initData?.vehicleCommunicationCodes?.length) return;

    try {
      const response = await operatorApiService.doGetOnevehicleLayoutCheck({
        monitorConsoleId,
      });
      const resultCodes = (response?.vcc || []).map(
        (v: any) => v.vehicle_communication_code
      );
      const originalCodes = initData.vehicleCommunicationCodes.map(
        (v) => v.vehicle_communication_code
      );

      const isMismatch =
        resultCodes.length !== originalCodes.length ||
        resultCodes.some((code: any) => !originalCodes.includes(code)) ||
        originalCodes.some((code) => !resultCodes.includes(code));

      if (isMismatch) {
        window.location.reload();
      }
    } catch (e) {
      console.error("車両レイアウト確認エラー:", e);
    }
  };

  checkVehicleLayout();
};

export default startLayoutCheck;
